import { useMemo } from 'react'
import { ColumnDef } from '@tanstack/react-table'
import {
  ActionsColumn,
  DetailColumn,
  selectableColumns,
  Requirements,
} from './columns'
import { usePositionDetailContextValue } from '../../context/PositionDetailProvider'

export const useSelectedColumns = (): ColumnDef<Requirements[number]>[] => {
  const {
    state: { requirements },
  } = usePositionDetailContextValue()

  const columnsToDisplay = useMemo(() => {
    const filteredColumns = selectableColumns.map((column) => column.columnDef)

    return [...filteredColumns, DetailColumn, ActionsColumn]
  }, [requirements])

  return columnsToDisplay
}
